import { GetterTree } from 'vuex'
import { RootState } from '@/store'
import { State } from './state'

export type Getters = {
  isSceneLoaded(state: State): boolean
  isControlsEnabled(state: State): boolean

  isBagLoaded(state: State): boolean
  isAnimationFinished(state: State): boolean

  texDefaultN(state: State): string | null
  texBody(state: State): string | null
  texBodyN(state: State): string | null
}

export const getters: GetterTree<State, RootState> & Getters = {
  isSceneLoaded: (state) => state.isSceneLoaded,
  isControlsEnabled: (state) => state.isControlsEnabled,
  
  isBagLoaded: (state) => state.isBagLoaded,
  isAnimationFinished: (state) => state.isAnimationFinished,

  texDefaultN: (state) => state.texDefaultN,
  texBody: (state) => state.texBody,
  texBodyN: (state) => state.texBodyN,
}
